// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1KjWE","c_image":"style_c_image__3APea"};